import { InfoChip } from "UI/shared/atoms/chips/InfoChip";
import React from "react";

export const SellerProfileInfoChip: React.FC = () => {
  return <InfoChip color={"#004680"} label={"Bien"} />;
};
